"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var delayedLoadingCover_1 = require("spry-react/LoadingCover/delayedLoadingCover");
var delayInMs = 250;
var DelayedLoadingBanner = /** @class */ (function (_super) {
    __extends(DelayedLoadingBanner, _super);
    function DelayedLoadingBanner(props) {
        var _this = _super.call(this, props) || this;
        _this.timeout = null;
        _this.startTimer = function () {
            if (_this.timeout === null) {
                _this.timeout = window.setTimeout(_this.showBanner, delayInMs);
            }
        };
        _this.stopTimer = function () {
            if (_this.timeout !== null) {
                window.clearTimeout(_this.timeout);
                _this.timeout = null;
            }
        };
        _this.showBanner = function () {
            _this.stopTimer();
            _this.setState({ loadingBannerVisible: true });
        };
        _this.state = { loadingBannerVisible: props.active === delayedLoadingCover_1.ActiveState.Active };
        if (props.active === delayedLoadingCover_1.ActiveState.Passive) {
            _this.startTimer();
        }
        return _this;
    }
    DelayedLoadingBanner.prototype.render = function () {
        return React.createElement("div", { className: "loading-banner", style: { display: this.state.loadingBannerVisible ? "block" : "none" } }, "Loading...");
    };
    DelayedLoadingBanner.prototype.componentWillReceiveProps = function (nextProps) {
        if (nextProps.active === delayedLoadingCover_1.ActiveState.Passive) {
            if (!this.state.loadingBannerVisible) {
                this.startTimer();
            }
        }
        else if (nextProps.active === delayedLoadingCover_1.ActiveState.Active) {
            this.showBanner();
        }
        else {
            this.stopTimer();
            this.setState({ loadingBannerVisible: false });
        }
    };
    DelayedLoadingBanner.prototype.componentWillUnmount = function () {
        this.stopTimer();
    };
    return DelayedLoadingBanner;
}(React.Component));
exports.DelayedLoadingBanner = DelayedLoadingBanner;
